import styled, { css } from 'styled-components'

import { colors } from 'bl-common/src/constants/colors'
import { gridOffsetFrom } from 'bl-common/src/constants/sizes'
import { Link } from 'bl-common/src/elements/Link'
import { Type } from 'bl-common/src/elements/Typography/Typography'
import { Section } from 'bl-common/src/units/Section/Section'
import { media, mediaMax } from 'bl-common/src/utils/media'

const Container = styled.div`
  border-top: 1px solid #bfbfbf;
  border-bottom: 1px solid #bfbfbf;
  margin: 0 -${gridOffsetFrom}px;
  padding: 32px ${gridOffsetFrom}px;

  ${media.md(css`
    width: calc((7 / 12) * 100%);
    margin-left: calc((2 / 12) * 100%);
    margin-top: ${({ theme }) => theme.spacing[2]};
    margin-bottom: ${({ theme }) => theme.spacing[2]};
    padding: ${({ theme }) => theme.spacing[3]} 0;
  `)}
`

const Tags = styled.div`
  display: flex;
  flex-wrap: wrap;
  ${mediaMax.md(css``)}
  ${media.md(css``)}
`

const Tag = styled(Link)`
  background: ${colors.lightGrey};
  border-radius: 8px;
  padding: 8px 24px;
  color: ${colors.deepBlue};
  cursor: pointer;
  margin-bottom: 16px;
  &:not(:last-of-type) {
    margin-right: 16px;
  }

  > * {
    position: relative;
    top: 1px;
    transition: none;
  }

  &:hover {
    color: ${colors.lightGrey};
    background: ${colors.deepBlue};
  }
`

export const TagCollection = ({ tags, heading, top = {}, bottom = {} }) => (
  <Section top={top} bottom={bottom}>
    <Container>
      <div>
        <Type preset="textSmall" bottom={{ xs: 1 }}>
          {heading}
        </Type>
      </div>
      <Tags>
        {tags.map(tag => (
          <Tag to={`/stories/tag/${tag.fields.slug}`} key={tag.fields.slug}>
            <Type size={{ xs: 10, md: 11 }} weight="bold">
              {tag.fields.name}
            </Type>
          </Tag>
        ))}
      </Tags>
    </Container>
  </Section>
)
